import { loadLevel, saveLevel } from '../data/load';
import { LevelSchema } from '@/data/level';
import { isEqual } from 'lodash';
import React, { useRef, useState } from 'react';

export function LevelPanel() {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [testResult, setTestResult] = useState<string | null>(null);

  const handleFileLoad = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = e => {
      try {
        const rawLevelData = JSON.parse(e.target?.result as string);
        const levelData = LevelSchema.parse(rawLevelData);
        loadLevel(levelData);
      } catch (error) {
        console.error('Invalid JSON file:', error);
      }
    };
    reader.readAsText(file);
  };

  const handleLoad = () => {
    fileInputRef.current?.click();
  };

  const handleSave = () => {
    const levelData = saveLevel();
    const blob = new Blob([JSON.stringify(levelData, null, 2)], {
      type: 'application/json',
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${levelData.levelName || 'level'}.json`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleTest = () => {
    fileInputRef.current?.click();

    const onFileLoad = (event: Event) => {
      const input = event.target as HTMLInputElement;
      const file = input.files?.[0];
      if (!file) return;

      const reader = new FileReader();
      reader.onload = e => {
        try {
          const rawLevelData = JSON.parse(e.target?.result as string);
          const levelData = LevelSchema.parse(rawLevelData);
          loadLevel(levelData);

          const savedLevelData = saveLevel();
          const isIdentical = isEqual(rawLevelData, savedLevelData);

          setTestResult(
            isIdentical
              ? 'Test Passed: JSON is identical'
              : 'Test Failed: JSON mismatch',
          );

          if (!isIdentical) {
            console.log('Original Level Data:', rawLevelData);
            console.log('Saved Level Data:', savedLevelData);
          }
        } catch (error) {
          console.error('Test failed due to error:', error);
          setTestResult('Test Failed: Invalid JSON or error occurred');
        }
      };
      reader.readAsText(file);

      // Remove the event listener after the test
      fileInputRef.current?.removeEventListener('change', onFileLoad);
    };

    fileInputRef.current?.addEventListener('change', onFileLoad);
  };

  return (
    <div className="pointer-events-auto rounded-xl border border-white/20 bg-[#08111fcc] px-3.5 py-3 backdrop-blur-sm">
      <button
        onClick={handleLoad}
        className="mb-2 w-full cursor-pointer rounded-md bg-white/10 px-3 py-1 text-sm text-white hover:bg-white/20"
      >
        Load Level
      </button>
      <input
        ref={fileInputRef}
        type="file"
        accept="application/json"
        onChange={handleFileLoad}
        className="hidden"
      />
      <button
        onClick={handleSave}
        className="w-full cursor-pointer rounded-md bg-white/10 px-3 py-1 text-sm text-white hover:bg-white/20"
      >
        Save Level
      </button>
      <button
        onClick={handleTest}
        className="mt-2 w-full cursor-pointer rounded-md bg-white/10 px-3 py-1 text-sm text-white hover:bg-white/20"
      >
        Test Level
      </button>
      {testResult && (
        <div className="mt-2 text-sm text-white/80">{testResult}</div>
      )}
    </div>
  );
}
